import { render, staticRenderFns } from "./ScreenLibros.vue?vue&type=template&id=80910c14"
import script from "./ScreenLibros.vue?vue&type=script&lang=js"
export * from "./ScreenLibros.vue?vue&type=script&lang=js"
import style0 from "./ScreenLibros.vue?vue&type=style&index=0&id=80910c14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports